<template>
  <Loader :style="style" :color="color" size="25px"/>
</template>

<script>
import Loader from "vue-spinner/src/MoonLoader.vue";

export default {
  props: ["width", "heigth"],
  components: {
    Loader
  },
  data() {
    return {
      style: {
        width: this.width,
        height: this.height
      },
      color: '#008cfe'
    };
  }
};
</script>